import * as actionTypes from '~/store/actions/actionTypes';
// eslint-disable-next-line import/no-cycle
import { statusSystem } from './system';

export const changeStatus = newStatus => (dispatch, getState) => {
  const systemStatus = getState().system.status;

  if (!systemStatus) {
    dispatch(statusSystem(newStatus));
  } else if (newStatus === 'Available') {
    dispatch({
      type: actionTypes.CHANGE_STATUS,
      payload: {
        status: newStatus,
      },
    });
  } else {
    dispatch({
      type: actionTypes.CHANGE_STATUS,
      payload: {
        status: systemStatus,
      },
    });
  }
};

export const issueReport = issue => dispatch => {
  switch (issue) {
    case 'LOST_CONNECTION':
      dispatch({
        type: actionTypes.ISSUE_REPORT,
        payload: {
          netWorkConnection: false,
        },
      });
      break;
    default:
      dispatch({
        type: actionTypes.ISSUE_REPORT_RESET,
      });
      break;
  }
};

export const forceChangeStatus = (valueStatus, issue = null) => dispatch => {
  dispatch(issueReport(issue));

  dispatch(statusSystem(valueStatus));

  dispatch({
    type: actionTypes.CHANGE_STATUS,
    payload: {
      status: valueStatus,
    },
  });
};

export const resetStatus = () => dispatch => {
  dispatch({ type: actionTypes.RESET_STATUS });
};
